import { render, staticRenderFns } from "./BuyTimeType.vue?vue&type=template&id=01c6f678&scoped=true&"
import script from "./BuyTimeType.vue?vue&type=script&lang=js&"
export * from "./BuyTimeType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01c6f678",
  null
  
)

export default component.exports